// skip grunt-raven-wrap

define((require, exports, module) => {
    'use strict';

    const element = document.createElement('div');

    /**
     * @param {string} html
     * @returns {string}
     */
    function removeHtml(html) {
        element.innerHTML = html;

        const text = element.textContent;

        element.innerHTML = '';

        return text;
    }

    module.exports = removeHtml;
});
